<div class="dispatch-sheet-container">


  <!-- Page Header -->
  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()" title="Go Back">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
        Go Back
      </button>
    </div>
    <div class="header-actions">
      <button *ngIf="isGmailUser()" class="btn btn-secondary" (click)="accessSheet()" [disabled]="isAccessingSheet">
        <i class="fa fa-spinner fa-spin" *ngIf="isAccessingSheet" style="margin-right: 8px;"></i>
        <svg *ngIf="!isAccessingSheet" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
        </svg>
        <span *ngIf="!isAccessingSheet">Access Sheet</span>
        <span *ngIf="isAccessingSheet">Accessing...</span>
      </button>
      <button *ngIf="showSyncSheetButton" class="btn btn-secondary" (click)="syncFromSheet()" [disabled]="isSyncing">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span>{{ isSyncing ? 'Syncing...' : 'Sync Sheet' }}</span>
      </button>
      <button class="btn btn-secondary" (click)="saveAll()" [disabled]="isSyncing">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span>{{ isSyncing ? 'Syncing...' : 'Sync' }}</span>
      </button>
      <button class="btn btn-secondary" (click)="openArchivedSheetsModal()">
        <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>
        <span>Archived Sheets</span>
      </button>

      <button class="btn btn-danger" *ngIf="hasSelectedRows()" (click)="deleteSelectedRows()">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
        <span>Delete Selected ({{ getSelectedCount() }})</span>
      </button>
    </div>
  </div>

  <div class="format-hint">
    <div class="hint-grid">
      <ng-container *ngFor="let col of columnHintPairs; let idx = index">
        <div class="grid-separator" *ngIf="idx > 0">|</div>
        <div class="hint-column" [class.active]="activeRowIndex !== null && getActiveColumnIndex() === idx"
          [class.filled]="activeRowIndex !== null && getValidationMap(rows[activeRowIndex]?.rawValue || '')[col.label] === 'valid'"
          [class.invalid]="activeRowIndex !== null && getValidationMap(rows[activeRowIndex]?.rawValue || '')[col.label] === 'invalid'">
          <div class="hint-col-label">
            {{ getCleanLabel(col.label) }}<span class="required" *ngIf="col.label.endsWith('*')">*</span>
          </div>
          <div class="hint-col-example">
            {{ col.example }}
          </div>
        </div>
      </ng-container>
      <div class="grid-separator">|</div>
    </div>
  </div>

  <!-- Sheet Grid -->
  <div class="sheet-grid-wrapper">
    <!-- Column Header -->
    <div class="grid-header-row">
      <div class="row-num-header">
        <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)"
          (mousedown)="$event.stopPropagation()" />
      </div>
      <div class="col-data-header">Orders</div>
      <div class="col-action-header"></div>
    </div>

    <!-- Rows -->
    <div class="grid-body" *ngIf="!isLoading && !isSyncing">
      <div class="grid-row" *ngFor="let row of rows; let i = index" [class.row-active]="activeRowIndex === i"
        [class.row-dirty]="row.isDirty">
        <div class="row-num">
          <input type="checkbox" [(ngModel)]="row.selected" (mousedown)="$event.stopPropagation()" />
          <span class="row-index-num">{{ i + 1 }}</span>
        </div>
        <div class="cell-wrapper">
          <input #cellInput class="cell-input" type="text" [(ngModel)]="row.rawValue"
            (focus)="onRowFocus(i); updateActiveSegment($event, row.rawValue)" (blur)="onRowBlur(i)"
            (input)="onRowInput(i, $event)" (click)="updateActiveSegment($event, row.rawValue)"
            (keyup)="updateActiveSegment($event, row.rawValue)" (keydown)="onKeyDown($event, i)"
            (keydown.enter)="onEnterKey(i, $event)" (keydown.tab)="onTabKey($event, i)" (paste)="onPaste($event, i)"
            (scroll)="onInputScroll($event)"
            [placeholder]="activeRowIndex === i ? '' : (row.rawValue ? '' : 'Click to enter sheet data...')"
            autocomplete="off" spellcheck="false" />

          <div class="cell-overlay" *ngIf="activeRowIndex === i">
            <span *ngFor="let part of getOverlayParts(row.rawValue)" [class.overlay-typed]="part.isTransparent"
              [class.overlay-placeholder]="!part.isTransparent && !part.isStar && !part.isActive"
              [class.overlay-active]="part.isActive" [class.overlay-star]="part.isStar">{{ part.text }}</span>
          </div>
        </div>

        <!-- Floating Company Autocomplete Dropdown -->
        <div class="driver-autocomplete-dropdown company-dropdown"
          *ngIf="activeRowIndex === i && companyDropdownVisible" [style.left.px]="companyDropdownLeft">
          <div *ngFor="let item of companyDropdownItems; let idx = index" class="driver-dropdown-item"
            [class.active]="idx === companyDropdownIndex"
            (mousedown)="acceptCompanyItem(getCompanyLabel(item), cellInput, i, item); $event.preventDefault()">
            <svg class="driver-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5m0 0h4" />
            </svg>
            <span class="driver-name-text">{{ getCompanyLabel(item) }}</span>
            <span class="driver-shortcut-hint" *ngIf="idx === companyDropdownIndex">↵ Enter</span>
          </div>
        </div>

        <!-- Floating Address Autocomplete Dropdown -->
        <div class="driver-autocomplete-dropdown address-dropdown"
          *ngIf="activeRowIndex === i && addressDropdownVisible" [style.left.px]="addressDropdownLeft">
          <div *ngFor="let item of addressDropdownItems; let idx = index" class="driver-dropdown-item"
            [class.active]="idx === addressDropdownIndex"
            (mousedown)="acceptAddressItem(getAddressLabel(item), cellInput, i, item); $event.preventDefault()">
            <svg class="driver-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span class="driver-name-text">{{ getAddressLabel(item) }}</span>
            <span class="driver-shortcut-hint" *ngIf="idx === addressDropdownIndex">↵ Enter</span>
          </div>
        </div>

        <!-- Floating Driver Autocomplete Dropdown (placed at grid-row level to avoid overflow clipping) -->
        <div class="driver-autocomplete-dropdown" *ngIf="activeRowIndex === i && driverDropdownVisible"
          [style.left.px]="driverDropdownLeft">
          <div *ngFor="let item of driverDropdownItems; let idx = index" class="driver-dropdown-item"
            [class.active]="idx === driverDropdownIndex" (mousedown)="acceptDropdownItem(item, cellInput, i)">
            <svg class="driver-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span class="driver-name-text">{{ item }}</span>
            <span class="driver-shortcut-hint" *ngIf="idx === driverDropdownIndex">↵ Enter</span>
          </div>
        </div>
        <div class="row-actions">
          <button class="row-action-btn delete-btn" (click)="deleteRow(i)" title="Delete row">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Bottom add buttons -->
      <div class="grid-bottom-actions">
        <button class="add-btn-pill" (click)="addMultipleRows(1)">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Add a row
        </button>
        <button class="add-btn-pill" (click)="addMultipleRows(5)">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Add 5 rows
        </button>
        <button class="add-btn-pill" (click)="addMultipleRows(10)">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Add 10 rows
        </button>
      </div>
    </div>

    <!-- Skeleton -->
    <div class="grid-body" *ngIf="isLoading || isSyncing">
      <div class="grid-row" *ngFor="let item of [1,2,3,4,5,6,7,8]">
        <div class="row-num skeleton-num"></div>
        <div class="cell-wrapper">
          <div class="skeleton-cell"></div>
        </div>
        <div class="row-actions"></div>
      </div>
    </div>
    <!-- Footer -->
    <div class="sheet-footer">
      <span>{{ rows.length }} row(s)</span>
      <span *ngIf="unsavedCount > 0" class="unsaved-indicator">
        ● {{ unsavedCount }} unsaved
      </span>
    </div>
  </div>

  <!-- Archived Sheets Modal -->
  <div class="modal-overlay" *ngIf="showArchivedSheetsModal" (click)="closeArchivedSheetsModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Archived Order Sheets Logs</h3>
        <button type="button" class="modal-close-btn" (click)="closeArchivedSheetsModal()">
          <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <!-- Date Selector -->
        <div class="modal-date-filter">
          <label for="logDateInput">Select Date:</label>
          <input type="date" id="logDateInput" class="modal-date-input" [(ngModel)]="logDateFilter"
            (change)="fetchArchivedSheetsLogs()" />
        </div>

        <!-- Loading Spinner -->
        <div class="modal-loading" *ngIf="isLoadingSheetsLogs">
          <div class="spinner"></div>
          <span>Loading sheets logs...</span>
        </div>

        <!-- Sheets List -->
        <div class="sheets-list" *ngIf="!isLoadingSheetsLogs && archivedSheetsLogs.length > 0">
          <div class="sheet-item" *ngFor="let log of archivedSheetsLogs">
            <div class="sheet-info">
              <h4 class="sheet-name" [matTooltip]="log.archived_sheet_name">{{ log.archived_sheet_name }}</h4>

              <div class="sheet-meta">
                <!-- User Profile Image / Initials -->
                <div class="admin-profile">
                  <img *ngIf="log.imported_by?.profile_image" [src]="log.imported_by.profile_image"
                    class="admin-avatar-img" />
                  <div *ngIf="!log.imported_by?.profile_image" class="admin-avatar-initials">
                    {{ (log.imported_by?.first_name?.charAt(0) || '') + (log.imported_by?.last_name?.charAt(0) || '') }}
                  </div>
                  <div class="admin-details">
                    <span class="admin-name">{{ log.imported_by?.first_name }} {{ log.imported_by?.last_name }}</span>
                    <span class="admin-role">{{ log.imported_by?.email }} ({{ log.imported_by?.user_role }})</span>
                  </div>
                </div>

                <div class="import-time">
                  <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span class="time-label">Added at:</span>
                  <span class="time-val">{{ log.imported_at | date:'medium' }}</span>
                </div>
              </div>
            </div>

            <div class="sheet-actions">
              <a *ngIf="isGmailUser()" [href]="log.archived_sheet_url" target="_blank" class="btn-access-sheet">
                <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
                Access Sheet
              </a>
              <button type="button" (click)="exportArchivedSheet(log)" class="btn-export-sheet"
                [disabled]="log.isExporting">
                <i *ngIf="log.isExporting" class="fa fa-spinner fa-spin" style="margin-right: 6px;"></i>
                <svg *ngIf="!log.isExporting" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>
                <span>{{ log.isExporting ? 'Exporting...' : 'Export Sheet' }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div class="modal-empty" *ngIf="!isLoadingSheetsLogs && archivedSheetsLogs.length === 0">
          <svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
          <p>No sheet import logs found.</p>
        </div>
      </div>
    </div>
  </div>

</div>